import moment, {Moment} from 'moment';

/**
 * Date formats for date picker.
 */
export const DateFormats = {
  parse: {
    dateInput: ['DD.MM.YYYY']
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

/**
 * Use this format to convert moment date to string before sending it to backend
 */
export const ApiDateFormat = 'DD.MM.YYYY';

/**
 * Use this format to convert returned date string to moment
 */
export const ApiReturnedDateFormat = 'YYYY-MM-DD';

export const dateToString = (date: Moment) => {
  const format = date != null ? date.format(ApiDateFormat) : null;
  return format;
};

export const parseDate = (date: string, dateFormat?: string): Moment => {
  const format = dateFormat ? dateFormat : ApiDateFormat;
  return date ? moment(date, format) : null;
};
